import { useState } from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap'
import CaseSearchForm from './CaseSearchForm'
import CaseSearch from './CaseSearch'

export default function CaseSelection({ objectId, field, callback, setSelectLargeChoice }) {
  console.log('CaseSelection rendered:')

  const [modal, setModal] = useState(true)
  const [caseSearch, setCaseSearch] = useState(<CaseSearchForm objectId={objectId} fieldId={field.id} caseSearchCallback={caseSearchCallback} />)
  const toggle = () => setModal(!modal)

  function exitModal () {
    toggle()
    setSelectLargeChoice(false) // updates state in AppObjectFieldSelect so the modal can get redrawn
  }

  function caseSearchCallback(url) {
    console.log('here')
    url = url.split('?') //url in this format fwinvoice.plaintiff_selection?inputs=${JSON.stringify(inputs)}
    const location = {pathname: `/custom/${url[0]}`, search: `?${url[1]}`}
    setCaseSearch(<CaseSearch 
      location={location} 
      largeChoiceCallback={callback} 
      caseSearchCallback={caseSearchCallback}
    />)
  }

  return (
    <Modal isOpen={modal} onExit={exitModal} backdrop='static' style={{ minWidth: '900px' }}>
      <ModalHeader toggle={toggle}>Search for {field.name} Records</ModalHeader>
      <ModalBody style={{ textAlign: 'left', display: 'inline-block', maxWidth: 'none'}}>{caseSearch}</ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={exitModal}>Ok</Button>
      </ModalFooter>
    </Modal>
  )
}
